export const getAllBusinessPerformancePermissions = (currentPermissions) => {
  const settings = currentPermissions && currentPermissions.permissionUser && currentPermissions.permissionUser.userPermissions;
  const group9 = settings ? settings.filter((item) => item.groupId === "9") : [];
  const group10 = settings ? settings.filter((item) => item.groupId === "10") : [];
  const group11 = settings ? settings.filter((item) => item.groupId === "11") : [];
  const group12 = settings ? settings.filter((item) => item.groupId === "12") : [];
  //   const group2 = settings ? settings.filter(item => item.groupId === "2") : [];

  const permissionsList1 = group9[0].permissions;
  const permissionsList2 = group10[0].permissions;
  const permissionsList3 = group11[0].permissions;
  const permissionsList4 = group12[0].permissions;

  return permissionsList1.concat(
    permissionsList2, permissionsList3, permissionsList4
  );
};

export const getVolDAffariSettings = (currentPermissions) => {
  const settings = currentPermissions && currentPermissions.permissionUser && currentPermissions.permissionUser.userPermissions;
  const group2 = settings ? settings.filter((item) => item.groupId === "2") : [];
  return group2[0].permissions.filter((item) => item.functionId === "77");
};
